module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "hd1"
  }, [_c('b', [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is dedicated with the deepest respect and love to my grandmother, Sadie Ruby. Sadie loved embroidery and passed her passion on to me. I am also dedicating this to my wonderful Scott, for his unlimited enthusiasm and support for my adventures in art and embroidery.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eca89886","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_dedication.vue
// module id = 63
// module chunks = 0